import { membershipService } from '@libs/data-access/queries'

export const useListenWS = () => {
  // Listen the notifications channel on WS
  membershipService.membership.notifications.useNotificationsWS({
    messages: {
      onNotificationUpdate: data => {
        membershipService.membership.notifications.updateNotificationsDataFromWS(
          data.data
        )
      }
    }
  })
}
